import Api, {
  baseURL,
  requestOptionsGET,
  // requestOptionsPOST,
  requestOptionsPOSTwithFormData,
  requestOptionsDELETE,
  requestOptionsPUT,
  requestOptionsPUTWithBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  manifest: [],
  manegementManifests: [],
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    CreatedAtStart: null,
    CreatedAtEnd: null,
    StatusId: null,
    SequenceCodesIntegration: null,
    ResponsibleUserId: null
  }
};

const getters = {
  getManifest: (state) => state.manifest,
  getManegementManifests: (state) => state.manegementManifests,
  getFilters: ({ paginate, filters }) => {
    return (
      `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}` +
      (filters.CreatedAtStart ? `&CreatedAtStart=${filters.CreatedAtStart}` : '') +
      (filters.CreatedAtEnd ? `&CreatedAtEnd=${filters.CreatedAtEnd}` : '') +
      (filters.StatusId ? `&StatusId=${filters.StatusId}` : '') +
      (filters.ResponsibleUserId ? `&ResponsibleUserId=${filters.ResponsibleUserId}` : '') +
      (filters.SequenceCodesIntegration && filters.SequenceCodesIntegration.length > 0
        ? filters.SequenceCodesIntegration.map((element) => `&SequenceCodesIntegration=${element}`).join('')
        : '')
    );
  }
};

const mutations = {
  setManifest(state, payload) {
    state.manifest = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setFilterCreatedAtStart(state, payload) {
    state.filters.CreatedAtStart = payload;
  },
  setFilterCreatedAtEnd(state, payload) {
    state.filters.CreatedAtEnd = payload;
  },
  setFilterStatusId(state, payload) {
    state.filters.StatusId = payload;
  },
  setFilterSequenceCodesIntegration(state, payload) {
    state.filters.SequenceCodesIntegration = payload;
  },
  setFilterResponsibleUserId(state, payload) {
    state.filters.ResponsibleUserId = payload;
  }
};

const actions = {
  fetchManifest(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManifest + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setManifest', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchNewManifest(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNewManifest + `?dateInitial=${body.dateInitial}&dateEnd=${body.dateEnd}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManifestByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getManifestById + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  createSheetPackages(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getSheetPackages,
        requestOptionsPOSTwithFormData(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  approveManifestImport(_, body) {
    const { sequenceCodes, advancesOnImportDto } = body;

    let financialData = {
      sequenceCodes
    };

    if (advancesOnImportDto != null) {
      financialData = {
        ...financialData,
        advancesOnImportDto
      };
    }

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.approveImportManifest + body.id,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), financialData)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  discardManifestImport(_, body) {
    return new Promise((resolve, reject) => {
      const { id } = body;
      newFetch(baseURL + Api.discartImportManifest + id, requestOptionsPUT(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  toogleShipment(_, prop) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getShipment + prop.type + prop.id, requestOptionsPUT(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchEditShipment(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.editShipment, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  sendtransferHierarchy(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transferHierarchy,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), { ...body })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  changeCompletionDate(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.changeCompletionDate + '?nfeId=' + body.nfeId + '&completionDate=' + body.completionDate,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getTranshipmentsManagementCtesOnTime(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipmentsManagementCtesOnTime + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsManagementCtesCriticalDay(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipmentsManagementCtesCriticalDay + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsManagementCtesLate(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipmentsManagementCtesLate + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteShipment(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteShipment + `/?id=${id}`, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
